import React, { useEffect, useState } from "react";
import { listLiveCarts } from "../../services/analytics";
import { ShoppingCart } from "lucide-react";

export default function AdminLiveCarts() {
  const [carts, setCarts] = useState([]);

  useEffect(() => {
    const load = () => listLiveCarts().then(setCarts).catch(() => {});
    load();
    const id = setInterval(load, 8000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="p-10" data-testid="admin-live-carts">
      <div className="flex items-end justify-between">
        <div>
          <div className="metadata">CANLI • 8s YENİLƏNMƏ</div>
          <h1 className="font-display text-5xl mt-2">Canlı Səbətlər</h1>
        </div>
        <div className="metadata text-[var(--accent)]">{carts.length} AKTİV</div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-8">
        {carts.length === 0 && <div className="text-[var(--text-2)] col-span-full metadata border border-[var(--border)] p-10 text-center">HƏLƏ AKTİV SƏBƏT YOXDUR</div>}
        {carts.map((c) => (
          <div key={c.id} className="border border-[var(--border)] p-5" data-testid={`cart-${c.id}`}>
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <ShoppingCart size={16} className="text-[var(--accent)]" />
                <div>
                  <div className="font-display text-lg">{c.user_email || "Anonim Ziyarətçi"}</div>
                  <div className="metadata text-[var(--text-muted)]">{c.updated_at?.toDate?.().toLocaleString() || "—"}</div>
                </div>
              </div>
              <div className="font-mono">₼{Number(c.total_azn || 0).toFixed(2)}</div>
            </div>
            <ul className="mt-4 space-y-2">
              {(c.items || []).map((i) => (
                <li key={i.product_id} className="flex gap-3 items-center text-sm">
                  {i.cover_url && <img src={i.cover_url} alt="" className="w-10 h-10 object-cover" />}
                  <div className="flex-1">
                    <div className="font-display text-base">{i.title}</div>
                    <div className="metadata text-[var(--text-muted)]">{i.artist_name} · ×{i.qty}</div>
                  </div>
                  <span className="font-mono text-xs">₼{Number(i.price_azn * i.qty).toFixed(2)}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
